import { useEffect, useMemo, useState } from 'react';
import { listCompanyHolidaysForRange, type CompanyHoliday } from '../../../api/companyHolidays';

function formatDateOnly(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function useCompanyHolidays() {
  const [holidays, setHolidays] = useState<CompanyHoliday[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    const now = new Date();
    const from = formatDateOnly(new Date(now.getFullYear() - 1, 0, 1));
    const to = formatDateOnly(new Date(now.getFullYear() + 1, 11, 31));

    setLoading(true);
    void listCompanyHolidaysForRange(from, to)
      .then((rows) => {
        if (!cancelled) {
          setHolidays(rows);
          setError(null);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setHolidays([]);
          setError(err instanceof Error ? err.message : 'Failed to load company holidays');
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  const disabledHolidayDates = useMemo(
    () =>
      holidays.map((h) => {
        const [y, m, d] = h.holidayDate.slice(0, 10).split('-').map(Number);
        return new Date(y, m - 1, d);
      }),
    [holidays]
  );

  return { holidays, loading, error, disabledHolidayDates };
}
